import { defineStore } from "pinia";
import { mapsService } from "@/_services";

export const mapsStore = defineStore("maps", {
  state: () => ({
    normalizedAddresses: null,
    error: null,
  }),

  actions: {
    normalizeAddress(query) {
      this.error = null;
      this.normalizedAddresses = null;
      return mapsService
        .normalizeAddress({ query })
        .then((result) => {
          this.normalizedAddresses = result;
          return result;
        })
        .catch((reason) => {
          this.error = reason;
          throw reason;
        });
    },
  },
});
